import React from "react";
import { MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { waLink } from "@/lib/constants";
import { track, Events } from "@/lib/analytics";

export default function WhatsAppButton({ message = "Hi, I'm interested in a property in Pune. Please share more details." }) {
  const { settings } = useApp();
  const number = settings?.whatsapp || "9325271272";
  return (
    <a
      data-testid="floating-whatsapp"
      href={waLink(number, message)}
      target="_blank"
      rel="noreferrer"
      onClick={() => track(Events.WHATSAPP, { where: "floating" })}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-105 transition-transform"
    >
      <MessageCircle className="h-7 w-7" aria-hidden />
    </a>
  );
}
